// extracted by mini-css-extract-plugin
module.exports =  {"allowLoadmoreBtnArea":"allowLoadmoreBtnArea__zwJZt"};